/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import { toNoticeProps } from './translator/notice'
import { toQuery, toQueryProps } from './translator/query'
import { EmptyResponsePropsFactory } from '@/entities/Response'
import { IQueryProps } from '@/entities/Query'
import { FetchNotice, GetNotice } from '@/infrastructure/network/Monitaro/requests/notice'

export default class Notice extends MonitaroGatewayBase {
  async FetchNotice(query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchNotice(toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.notices.map((prop) => toNoticeProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async GetNotice(id: string) {
    const { notice } = await this.apiClient.request(new GetNotice(id))
    return toNoticeProps(notice)
  }
}
